import React from 'react'
import { View, Text } from '@react-pdf/renderer'
import getStyles from './styles'
import { InputProps } from './types'
import { defaultTheme } from '~/styles/themes'

function PDFInformationalInput(props: InputProps) {
  const styles = getStyles(defaultTheme, props)

  return (
    <View style={styles.componentStructure}>
      <View style={styles.labelArea}>
        <Text style={styles.label}>{props.label}</Text>
      </View>
      <View style={styles.inputStructure}>
        <Text style={styles.input}>{props.value}</Text>
      </View>
    </View>
  )
}

export default PDFInformationalInput
